<template>
  <div class="form-group col-xs-12" :class="{ 'has-error': this.validation && this.validation.$error }">
    <div class="has-feedback">
      <select class="form-control" ref="select" :id="'select' + name" v-model="selectedOption" @change="updateValue" @blur="blur" :disabled="loading">
        <option disabled :value="undefined" id="optionDefault">{{ label }}</option>
        <option v-for="(option, index) in options" :value="option" :id="'option' + index">
          {{ option.name }}
        </option>
      </select>
      <span v-if="loading" class="form-control-feedback padding-right-15">
        <i class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></i>
      </span>
      <span v-if="required" class="glyphicon glyphicon-asterisk form-control-feedback padding-right-15"
        aria-hidden="true"></span>
      <span v-if="required" class="sr-only">(required)</span>
    </div>
    <div class="help-block small" role="alert" v-if="!loading && validation && validation.$error">
      <span v-if="requiredError">The field is required</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'input-select',
    props: {
      value: {
        type: Object,
        default() {
          return undefined;
        },
      },
      name: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
      validation: {
        type: Object,
        default() {
          return undefined;
        },
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      required() {
        return !this.loading && this.validation &&
          (
            this.validation.required !== undefined ||
            (
              !this.validation.requiredIf ||
              (this.value && this.validation.requiredIf !== undefined)
            )
          );
      },
      requiredError() {
        return this.validation && this.validation.$error &&
          (
            !this.validation.required &&
            !this.validation.requiredIf
          );
      },
    },
    methods: {
      blur() {
        // Only validate the input on blur
        if (this.validation) {
          this.validation.$touch();
        }
      },
      updateValue() {
        this.$emit('input', this.selectedOption);
      },
    },
    created() {
      this.selectedOption = this.value;
    },
    mounted() {
      if (this.validation && this.required) {
        this.$refs.select.required = true;
      }
    },
    beforeUpdate() {
      this.selectedOption = this.value;

      if (this.validation && this.required) {
        this.$refs.select.required = true;
      }
    },
    data() {
      return {
        selectedOption: undefined,
      };
    },
  };

</script>

<style scoped>
  .padding-right-15 {
    padding-right: 15px;
  }

  select:invalid {
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// InputSelect.vue?20b6e101